import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DialogService } from '../../../dialog';
import { FeedbackData, FeedbackStyle } from '../../_models';

@Component({
	selector: 'app-feedback-plain-dialog',
	templateUrl: './plain-dialog.component.html',
	styleUrls: ['../../index.scss']
})
export class PlainDialogComponent implements OnInit {
	private dialogRefClose: () => void;

	public style: FeedbackStyle;
	public contentClass = '';

	constructor(
		private dialogService: DialogService,
		private dialogRef: MatDialogRef<PlainDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: FeedbackData
	) {
		this.dialogRefClose = this.dialogService.interceptClose(this.dialogRef, this, this.closeDialog);
	}

	public ngOnInit(): void {
		this.style = this.dialogData.style ?? FeedbackStyle.plain;
		this.contentClass = this.dialogData?.contentClass ? this.dialogData.contentClass : '';
	}

	public save(): void {
		if (this.dialogData.callback) this.dialogData.callback();

		this.closeDialog();
	}

	private closeDialog(): void {
		this.dialogRefClose();
	}
}
